import { Formik } from 'formik';
import React from 'react'
import RegisterDTO from '../../../Models/RegisterDTO';
import { useStore } from '../../../Stores/store';

const inputClass = "w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-500";
const labelClass = "text-sm font-medium text-gray-700";

export default function RegisterForm(){
    const { managementStore } = useStore();
    const { register } = managementStore;

    const formVals : RegisterDTO = {
        email : "",
        password: "",
        secretKey: ""
    }

    const handleSubmit = (values : any) => {
        register(values);
    }

    return (
        <div className="w-full">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">Register</h2>
            <Formik
                initialValues={formVals}
                onSubmit={(values) => handleSubmit(values)}
                enableReinitialize
            >
                {({handleSubmit, handleChange, values}) => (
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                        <div className="flex flex-col gap-1">
                            <label htmlFor="email" className={labelClass}>Email</label>
                            <input type="text" name="email" id="email" value={values.email} onChange={handleChange} className={inputClass} />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label htmlFor="password" className={labelClass}>Password</label>
                            <input type="password" id="password" name="password" value={values.password} onChange={handleChange} className={inputClass} />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label htmlFor="secretKey" className={labelClass}>Secret Key</label>
                            <input type="password" id="secretKey" name="secretKey" value={values.secretKey} onChange={handleChange} className={inputClass} />
                        </div>
                        <button type="submit" className="w-full mt-2 bg-gray-800 text-white py-2 px-4 rounded-md hover:bg-gray-700 transition-colors text-sm font-medium cursor-pointer">
                            Register
                        </button>
                    </form>
                )}
            </Formik>
        </div>
    );
}